import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_hecnos-staging/artifacts/7k2clrrd_Hecnos_logo_fond_blanc-removebg-preview.png";

export const Logo = ({ variant = "dark", height = 40, className = "" }) => {
  return (
    <div className={`flex items-center ${className}`} data-testid="hecnos-logo">
      <img
        src={LOGO_URL}
        alt="Hecnos"
        style={{ height, width: "auto", objectFit: "contain" }}
        className={variant === "light" ? "brightness-0 invert" : ""}
      />
    </div>
  );
};

export default Logo;
